var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"checkbox-radio",class:{active: _vm.id === _vm.value}},[_c('div',{staticClass:"items"},[_vm._t("default"),_c('input',{attrs:{"type":"radio"},domProps:{"value":_vm.value,"checked":_vm.value === _vm.id},on:{"change":function($event){return _vm.$emit('input', _vm.id)}}})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }